const END_POINT = '/languages'

import BasicCrudAPI from './basicCrud.api.js'

const LanguagesAPI = new BasicCrudAPI(END_POINT)

export default LanguagesAPI
